import BlocksContainer from "./BlocksContainer"

const Blocks = (props) => {
  return <BlocksContainer mode="view" {...props} />
}

export default Blocks
